import * as React from 'react';
import { cn } from '@/lib/utils';

export interface AlanProps extends React.InputHTMLAttributes<HTMLInputElement> {
  etiket: string;
  /** OCR guven skoru 0-1; esigin altindaysa alan sari vurgulanir */
  guven?: number | null;
  dikkat?: boolean;
  hata?: string | null;
  ipucu?: string;
}

/**
 * Tek bir form alani.
 * OCR'den gelen dusuk guvenli veya tutarsiz alanlar SARI cerceve ile isaretlenir;
 * resepsiyonist bakmadan gecemez. Hicbir alan sessizce kabul edilmez.
 */
export const Alan = React.forwardRef<HTMLInputElement, AlanProps>(function Alan(
  { etiket, guven, dikkat, hata, ipucu, className, id, ...props },
  ref,
) {
  const alanId = id ?? React.useId();
  const dusukGuven = dikkat || (guven !== null && guven !== undefined && guven < 0.85);

  return (
    <div className="flex flex-col gap-1.5">
      <label htmlFor={alanId} className="flex items-center gap-2 text-sm font-medium text-slate-700">
        {etiket}
        {dusukGuven && !hata && (
          <span className="rounded-full bg-amber-100 px-2 py-0.5 text-xs font-semibold text-amber-800">
            kontrol edin
          </span>
        )}
      </label>
      <input
        ref={ref}
        id={alanId}
        className={cn(
          'h-12 w-full rounded-lg border border-slate-300 bg-white px-3 text-base',
          'focus:border-marka-500 focus:outline-none focus:ring-2 focus:ring-marka-100',
          dusukGuven && 'alan-dikkat',
          hata && 'alan-hata',
          className,
        )}
        aria-invalid={Boolean(hata)}
        {...props}
      />
      {hata ? (
        <p className="text-sm text-red-600">{hata}</p>
      ) : ipucu ? (
        <p className="text-sm text-slate-500">{ipucu}</p>
      ) : null}
    </div>
  );
});

export function Secim({
  etiket,
  secenekler,
  dikkat,
  className,
  ...props
}: React.SelectHTMLAttributes<HTMLSelectElement> & {
  etiket: string;
  dikkat?: boolean;
  secenekler: { deger: string; metin: string }[];
}) {
  const id = React.useId();
  return (
    <div className="flex flex-col gap-1.5">
      <label htmlFor={id} className="text-sm font-medium text-slate-700">
        {etiket}
      </label>
      <select
        id={id}
        className={cn(
          'h-12 w-full rounded-lg border border-slate-300 bg-white px-3 text-base',
          'focus:border-marka-500 focus:outline-none focus:ring-2 focus:ring-marka-100',
          dikkat && 'alan-dikkat',
          className,
        )}
        {...props}
      >
        {secenekler.map((s) => (
          <option key={s.deger} value={s.deger}>
            {s.metin}
          </option>
        ))}
      </select>
    </div>
  );
}
